/* eslint-disable no-magic-numbers */
import L from 'leaflet';
import * as leafletPip from '@mapbox/leaflet-pip';
import geometryUtil from 'leaflet-geometryutil';

export function getWKTBounds(bounds) {
  return `POLYGON((
    ${bounds.getEast()} ${bounds.getNorth()},
    ${bounds.getWest()} ${bounds.getNorth()},
    ${bounds.getWest()} ${bounds.getSouth()},
    ${bounds.getEast()} ${bounds.getSouth()},
    ${bounds.getEast()} ${bounds.getNorth()}
  ))`;
}

export function getMeterSize({ map, latLng, bearing = 90, length = 1, from = 1 }) {
  const newLatLng = geometryUtil.destination(latLng, bearing, from);
  const pos = map.latLngToLayerPoint(newLatLng);
  const ne = geometryUtil.destination(newLatLng, bearing, length);
  const nePoint = map.latLngToLayerPoint(ne);
  const pixelWidth = nePoint.distanceTo(pos);

  return pixelWidth;
}

export function getOffsetFromReferencePoint(latLng, referencePoint, picCoordSize) {
  if (referencePoint) {
    const latOffset = Math.floor((latLng.lat - referencePoint.lat) / picCoordSize.lat);
    const lngOffset = Math.floor((latLng.lng - referencePoint.lon) / picCoordSize.lon);

    return { latOffset, lngOffset };
  }

  return null;
}

export function getLatLngFromOffset(latOffset, lngOffset, referencePoint, picCoordSize) {
  if (referencePoint && picCoordSize) {
    return L.latLng(referencePoint.lat + (latOffset * picCoordSize.lat), referencePoint.lon + (lngOffset * picCoordSize.lon));
  }

  return null;
}

export function getSquareFromOffset(latOffset, lngOffset, referencePoint, picCoordSize) {
  const sw = getLatLngFromOffset(latOffset, lngOffset, referencePoint, picCoordSize);
  const ne = getLatLngFromOffset(latOffset + 1, lngOffset + 1, referencePoint, picCoordSize);

  return {
    bounds: L.latLngBounds(sw, ne),
    offset: {
      latOffset,
      lngOffset,
    },
  };
}

export function getSquareFromLatLng(latLng, referencePoint, picCoordSize, size) {
  const offset = getOffsetFromReferencePoint(latLng, referencePoint, picCoordSize);

  return getSquareFromOffset(offset.latOffset, offset.lngOffset, referencePoint, picCoordSize, size);
}

export function findAreaByPoint(point, areas) {
  return areas.find((area) =>
    leafletPip.pointInLayer(point, area.geometry, true).length > 0
  );
}

export function isBoundsInsideArea(bounds, areas) {
  const corners = [
    bounds.getNorthWest(),
    bounds.getNorthEast(),
    bounds.getSouthWest(),
    bounds.getSouthEast(),
  ];
  const intersect = corners.filter(corner => findAreaByPoint(corner, areas));

  return intersect.length === 4;
}
